import { NgModule } from '@angular/core';
import { BypassSecurityTrustResourceUrlPipe } from './bypass-security-trust-resource-url/bypass-security-trust-resource-url.pipe';
import { CompactNumberPipe } from './compact-number/compact-number.pipe';
import { FreelancerCurrencyPipe } from './currency/currency.pipe';
import { DateRangePipe } from './date-range/date-range.pipe';
import { DecodeUriComponentPipe } from './decode-uri-component/decode-uri-component.pipe';
import { DurationPipe } from './duration/duration.pipe';
import { DynamicTimePipe } from './dynamic-time/dynamic-time.pipe';
import { FileSizePipe } from './file-size/file-size.pipe';
import { IsOnlinePipe } from './is-online/is-online.pipe';
import { LocationPipe } from './location/location.pipe';
import { OnlineOfflineStatusPipe } from './online-offline-status/online-offline-status.pipe';
import { PascalCasePipe } from './pascal-case/pascal-case.pipe';
import { SanitisePipe } from './sanitise/sanitise.pipe';
import { StripUrlPipe } from './strip-url/strip-url.pipe';
import { TruncateFilenamePipe } from './truncate-filename/truncate-filename.pipe';

@NgModule({
  declarations: [
    CompactNumberPipe,
    BypassSecurityTrustResourceUrlPipe,
    FileSizePipe,
    DateRangePipe,
    DurationPipe,
    IsOnlinePipe,
    LocationPipe,
    OnlineOfflineStatusPipe,
    PascalCasePipe,
    SanitisePipe,
    TruncateFilenamePipe,
    StripUrlPipe,
    DynamicTimePipe,
  ],
  imports: [FreelancerCurrencyPipe, DecodeUriComponentPipe],
  exports: [
    CompactNumberPipe,
    BypassSecurityTrustResourceUrlPipe,
    FileSizePipe,
    FreelancerCurrencyPipe,
    DateRangePipe,
    DurationPipe,
    IsOnlinePipe,
    LocationPipe,
    OnlineOfflineStatusPipe,
    PascalCasePipe,
    SanitisePipe,
    TruncateFilenamePipe,
    StripUrlPipe,
    DynamicTimePipe,
    DecodeUriComponentPipe,
  ],
  providers: [
    CompactNumberPipe,
    BypassSecurityTrustResourceUrlPipe,
    FileSizePipe,
    FreelancerCurrencyPipe,
    DurationPipe,
    IsOnlinePipe,
    OnlineOfflineStatusPipe,
    PascalCasePipe,
    SanitisePipe,
    TruncateFilenamePipe,
    StripUrlPipe,
    DynamicTimePipe,
    DecodeUriComponentPipe,
  ],
})
export class PipesModule {}
